import React from 'react';
import config from '../../../config'

import {
  LuklaFAQ,
  CommonFAQ,
  ImportantNotice,
} from '../SearchAndResults/StaticSections';
import { sectors, subTitle, appendStatic } from './common';

const pageTitle = 'Kathmandu to Lukla Flight at USD 170.8';

const everest = {
  pageTitle,
  subTitle,
  CreditMessage: () => (
    <p className="ext-word">
      * If you run into any problem, please Call/WhatsApp Ngawang <a href={`https://wa.link/2fcybs`} target="_blank" rel="noopener noreferrer" style={{ color: '#00C0FF', textShadow: 'rgba(0, 0, 0, 1) 0px 0px 5px', fontWeight: '700' }}>
        {config.honeyguidePhoneNumber}
      </a> or you can Email at <a
          target="_blank" rel="noopener noreferrer"
          href={`mailto:${config.honeyguideEmail}`}
          style={{ color: '#00C0FF', textShadow: 'rgba(0, 0, 0, 1) 0px 0px 5px', fontWeight: '700' }}
        >
          {config.honeyguideEmail}
        </a>{' '}
    </p>
  ),
  seo: {
    title: appendStatic(pageTitle),
    description:
      'Get upto USD 9 Credits with each ticket. 24x7 hours support from people who know the mountains. 72 hours Free Cancellation. Online Flight Booking between Kathmandu and Lukla',
    image:
      'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  from: 'KTM',
  to: 'LUA',
  sectors,
  valueProps: [
    'Although most flights operate from Manthali Airport, we have Direct Kathmandu-Lukla Flights. (LIMITED SEATS REMAINING!)',
    'In case no direct flights are available, we will arrange transportation from Kathmandu To Manthali.',
    'Price Match Guarantee',
    'Free 24 hours cancellation',
    '24x7 support from HoneyGuide',
  ],
  // Notice: () => <ImportantNotice />,
  Faq: () => (
    <React.Fragment>
      <LuklaFAQ />
      <CommonFAQ />
    </React.Fragment>
  ),
  lodge: {
    placeName: 'Phakding',
    placeId: 'd70fb00afee1',
    limit: '2',
    region: 'everest',
  },
  pricesToCompare: [
    { url: 'https://honeyguide.s3.amazonaws.com/assets/yeti-air2.png', price: 'USD 167.52', subText: '' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/sasto-tickets.png', price: 'USD 169', subText: '' },
    { url: 'https://honeyguide.s3.amazonaws.com/assets/kathmandu-lukla-flight.png', price: 'USD 180', subText: '' },
  ],
};

export default everest;



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/everest.js